import React, { useState } from "react";
import Nav from "./Navigation.js";

const Tickets = () => {
  const [chartData] = useState({
    NonStamped: {
      VerySmall: { Easy: 1, Normal: 2, Hard: 3, VeryHard: 4, Extreme: 5 },
      Small: { Easy: 2, Normal: 3, Hard: 4, VeryHard: 5, Extreme: 6 },
      Medium: { Easy: 3, Normal: 4, Hard: 5, VeryHard: 6, Extreme: 7 },
      Large: { Easy: 4, Normal: 5, Hard: 6, VeryHard: 7, Extreme: 8 },
      VeryLarge: { Easy: 5, Normal: 6, Hard: 7, VeryHard: 8, Extreme: 9 },
      Giant: { Easy: 6, Normal: 7, Hard: 8, VeryHard: 9, Extreme: 10 },
    },
    Rare: {
      VerySmall: { Easy: 2, Normal: 4, Hard: 6, VeryHard: 8, Extreme: 10 },
      Small: { Easy: 4, Normal: 6, Hard: 8, VeryHard: 10, Extreme: 12 },
      Medium: { Easy: 6, Normal: 8, Hard: 10, VeryHard: 12, Extreme: 14 },
      Large: { Easy: 8, Normal: 10, Hard: 12, VeryHard: 14, Extreme: 16 },
      VeryLarge: { Easy: 10, Normal: 12, Hard: 14, VeryHard: 16, Extreme: 18 },
      Giant: { Easy: 12, Normal: 14, Hard: 16, VeryHard: 18, Extreme: 20 },
    },
    Hardcore: {
      VerySmall: { Easy: 4, Normal: 8, Hard: 12, VeryHard: 16, Extreme: 20 },
      Small: { Easy: 8, Normal: 12, Hard: 16, VeryHard: 20, Extreme: 24 },
      Medium: { Easy: 12, Normal: 16, Hard: 20, VeryHard: 24, Extreme: 28 },
      Large: { Easy: 16, Normal: 20, Hard: 24, VeryHard: 28, Extreme: 32 },
      VeryLarge: { Easy: 20, Normal: 24, Hard: 28, VeryHard: 32, Extreme: 36 },
      Giant: { Easy: 24, Normal: 28, Hard: 32, VeryHard: 36, Extreme: 40 },
    },
  });

  return (
    <div>
      <Nav />
      <div className="p-4">
        <p className="text-white text-med text-center text-xl font-bold">
          Base Ticket Value System
        </p>
        <table className="text-slate-200 min-w-full bg-purple-900 border border-purple-900 rounded shadow text-center">
          <thead className="bg-purple-900">
            <tr>
              <th className="py-2 px-4 border-b">Size/Difficulty </th>
              <th className="py-2 px-4 border-b">Easy</th>
              <th className="py-2 px-4 border-b">Normal</th>
              <th className="py-2 px-4 border-b">Hard</th>
              <th className="py-2 px-4 border-b">Very Hard</th>
              <th className="py-2 px-4 border-b">Extreme</th>
            </tr>
          </thead>
          <tbody className="font-semibold">
            {Object.keys(chartData).map((category) => (
              <React.Fragment key={category}>
                <tr>
                  <th
                    colSpan="7"
                    className="py-2 px-4 border-b text-left bg-gray-900"
                  >
                    {category}
                  </th>
                </tr>
                {Object.keys(chartData[category]).map((size) => (
                  <tr key={size}>
                    <td className="py-2 px-4 border-b">{size}</td>
                    {Object.keys(chartData[category][size]).map(
                      (difficulty) => (
                        <td key={difficulty} className="py-2 px-4 border-b">
                          {chartData[category][size][difficulty]}
                        </td>
                      )
                    )}
                  </tr>
                ))}
              </React.Fragment>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default Tickets;
